import { ButtonBase } from '@mui/material';
import './PriceUpText.scss';

interface PriceUpTextProps {
  title: string;
  description: string;
  price: string | React.ReactNode;
  onClick: () => void;
}

const PriceUpText = ({
  title,
  description,
  price,
  onClick,
}: PriceUpTextProps) => {
  return (
    <ButtonBase onClick={onClick} className="dish dish--price-up-text">
      <div className="dish__body">
        <p className="dish__price">{price}</p>
        <h3 className="dish__title">{title}</h3>
        <p className="dish__description">{description}</p>
      </div>
    </ButtonBase>
  );
};

export default PriceUpText;
